"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SharePanelAnchor = SharePanelAnchor;
var _react = _interopRequireDefault(require("react"));
var _popover = require("@design/ui/popover");
var _portalLayer = require("./portal-layer");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var MODAL_LAYER_SELECTOR = '[role="dialog"], [role="alertdialog"]';
var SHARE_PANEL_GAP = 8;
function isInLayerAbovePanel(target, panel) {
  var targetLayer = target instanceof Element ? target.closest(_portalLayer.PORTAL_LAYER_SELECTOR) : null;
  return targetLayer !== null && !targetLayer.contains(panel);
}
function SharePanelAnchor(_ref) {
  var _anchorEl$closest;
  var anchorEl = _ref.anchorEl,
    onClose = _ref.onClose,
    children = _ref.children;
  var anchorRef = _react.default.useMemo(function () {
    return {
      current: anchorEl
    };
  }, [anchorEl]);
  var panelRef = _react.default.useRef(null);
  function isOutsideClickToIgnore(target) {
    var isOnAnchor = target instanceof Node && anchorEl.contains(target);
    return isOnAnchor || isInLayerAbovePanel(target, panelRef.current);
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_popover.Popover, {
    open: true,
    onOpenChange: function onOpenChange(open) {
      return open || onClose();
    },
    "data-sentry-element": "Popover",
    "data-sentry-component": "SharePanelAnchor",
    "data-sentry-source-file": "SharePanelAnchor.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_popover.PopoverAnchor, {
      virtualRef: anchorRef,
      "data-sentry-element": "PopoverAnchor",
      "data-sentry-source-file": "SharePanelAnchor.tsx"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_popover.PopoverContent, {
      ref: panelRef,
      container: (_anchorEl$closest = anchorEl.closest(MODAL_LAYER_SELECTOR)) !== null && _anchorEl$closest !== void 0 ? _anchorEl$closest : undefined,
      side: "bottom",
      align: "end",
      sideOffset: SHARE_PANEL_GAP,
      collisionPadding: SHARE_PANEL_GAP,
      className: "w-auto bg-transparent p-0 shadow-none ring-0",
      onInteractOutside: function onInteractOutside(event) {
        if (isOutsideClickToIgnore(event.target)) event.preventDefault();
      },
      onEscapeKeyDown: function onEscapeKeyDown(event) {
        if (isInLayerAbovePanel(event.target, panelRef.current)) event.preventDefault();
      },
      "data-sentry-element": "PopoverContent",
      "data-sentry-source-file": "SharePanelAnchor.tsx",
      children: children
    })]
  });
}